import { atom } from 'recoil';

type StatusType = 'idle' | 'loading' | 'success' | 'error';

export type ProfileAtomType = {
    status: { fetch: StatusType, update: StatusType, delete: StatusType };
    list: Array<object>;
    data: object;
    error: object;
}

export const profileInfoAtom = atom<ProfileAtomType>({
    key: 'profileInfoAtom',
    default: {
        status: {
            fetch: 'idle',
            update: 'idle',
            delete: 'idle',
        },
        list: [],
        data: {},
        error: []
    }
})
export const passwordInfoAtom = atom<ProfileAtomType>({
  key: 'passwordInfoAtom',
  default: {
      status: {
          fetch: 'idle',
          update: 'idle',
          delete: 'idle',
      },
      list: [],
      data: {},
      error: []
  }
})

// For Registration, I lazy to ammend
export interface ProfileActionStatusAtom {
  fetch: StatusType;
  create: StatusType;
}

export const profileActionStatusAtom = atom<ProfileActionStatusAtom>({
  key: 'profileActionStatusAtom',
  default: {
    fetch: 'idle',
    create: 'idle',
  }
});

export const profileDetailsAtom = atom({
  key: 'profileDetailsAtom',
  default: {}
});

export const profileDraftAtom = atom({
  key: 'profileDraftAtom',
  default: {}
})

export const profileErrorAtom = atom({
  key: 'profileErrorAtom',
  default: {}
});

